'use strict';

angular.module('far.mountains')
.controller('MountainsRoutesByPeakController', function($log, $http, $document, pagination, $q, mountainRoutes) {
	var oldMountainPeak = null;
	var vm = {
		hasSubmitted: false,
		pagination: pagination('mountainsRoutes', {next: nextPage, itemsOnPage: 9000}),
		mountainPeak: null,
		searchMountainRoutes: searchMountainRoutes,
		refreshAutocomplete: refreshAutocomplete,
		mountainPeaks: [],
		popularRoutes: [],
		totalPages: 0,
		getUserProfileUrl: getUserProfileUrl,
		getPeaksStringForRoute: getPeaksStringForRoute,
		getAreaStringForRoute: getAreaStringForRoute,
		getRegionStringForRoute: getRegionStringForRoute,
		getHeightStringForRoute: getHeightStringForRoute,
		getMountainRouteUrl: getMountainRouteUrl,
		addMyAscentUrl: addMyAscentUrl,
		trRouteClass: trRouteClass
	};

	function refreshAutocomplete(peakName) {
		vm.mountainPeaks.length = 0;

		if (!peakName) {
			return vm.mountainPeaks;
		}

		return $http.post(Routing.generate('api_entities_post_autocomplete'), {
			term: 'Mountain',
			search: peakName
		}).then(function(response) {
			vm.mountainPeaks.length =  0;
			response.data.forEach(function(peak) {
				vm.mountainPeaks.push(peak);
			});
		});
	}

	function searchMountainRoutes() {
		$document.scrollTopAnimated(350);

		vm.hasSubmitted = true;
		if (
			vm.mountainPeak &&
			(!oldMountainPeak || oldMountainPeak.id != vm.mountainPeak.id)
		) {
			vm.pagination.clear();
			if (!oldMountainPeak || oldMountainPeak.mountain_area_id != vm.mountainPeak.mountain_area_id) {
				getPopularRoutes({area_id: vm.mountainPeak.mountain_area_id});
			}
			oldMountainPeak = vm.mountainPeak;
		}
	}

	function nextPage(page, count) {
		return $http.get(Routing.generate('api_entities_get_mountainroutes', {
			offset: (page - 1) * count,
			limit: count,
			mountain_id: vm.mountainPeak.id
		})).then(function(response) {
			var items = [];
			vm.totalPages = Math.ceil(response.headers('X-Total-Count') / count);

			angular.forEach(response.data, function(item) {
				console.log(item[0]);
				items.push(item[0]);
			});

			return items;
		}).catch(function(response) {
			$log.error(response);
			return $q.reject(response);
		});
	}

	function getRegionStringForRoute(route) {
		var _return = [];
		route.mountain_peaks.map(function(peak) {
			_return.push(peak.mountain_region_name);
		});
		return _return[0];
	}

	function getAreaStringForRoute(route) {
		var _return = [];
		route.mountain_peaks.map(function(peak) {
			_return.push(peak.mountain_area_name);
		});
		return _return[0];
	}

	function getPeaksStringForRoute(route) {
		return route.mountain_peaks.map(function(peak) {
			var _return = [];
			
			if ( peak.name ) {
				_return.push(peak.name);
			}

			return _return.join(', ');
		}).join(' - ');
	}

	function getHeightStringForRoute(route) {
		var _return = [];
		route.mountain_peaks.map(function(peak) {
			_return.push(peak.height);
		});
		if(_return.length > 1) {
			return '';
		}
		return _return[0];
	}

	function getUserProfileUrl(route) {
		return Routing.generate('user_view', {userId: route.user.id});
	}

	function addMyAscentUrl(route) {
		return Routing.generate('personal_alpbook') + '#/?mountainroute=' + route.id;
	}

	function getMountainRouteUrl(route) {
		return Routing.generate('page_mountainroute_index', {'id': route.id});
	}

	function trRouteClass(status) {
		if(status) {
			return 'page-table__row'
		}
		return 'page-table__row_colored'
	}

	function getPopularRoutes(filters) {
		vm.popularRoutes = [];
		mountainRoutes.getPopular(filters)
				.then(function(routes) {
					angular.forEach(routes, function(route) {
						vm.popularRoutes.push(route[0]);
					});
				});
	}
	getPopularRoutes();

	return vm;
});